/* eslint-disable no-unused-vars */
import { observable, action, makeObservable } from 'mobx';
import { getProductDetail, createOrder, orderPay } from '@/api/Payment/order';
import ToastUtils from '@/utils/ToastUtils';
class Mall {
    constructor() {
        makeObservable(this);
    }
    @observable state = {
        data: {
            store_name: '思亲务',
            biz_info: [
                {
                    business_id: '1771067378536366082',
                    template_id: '107'
                }
            ]
        },

        sku_info: {
            price: '',
            stock: 0
        },
        biz_info: {}
    };

    @action
    setState = (v) => {
        this.state = v;
    };
    //获取商品详情
    getProductDetail = async (business_id) => {
        let res = await getProductDetail(business_id);
        if (res && res.success) {
            this.setState({
                data: res.data,
                sku_info: res.data.sku_info[0],
                biz_info: res.data.biz_info[0]
            });
        } else {
            ToastUtils.showAbnormalToast(res.msg);
            this.setState({
                sku_info: null,
                biz_info: null
            });
        }
        return res;
    };
    //创建订单
    creatOrder = async (data) => {
        let res = await createOrder(data);
        if (res && res.code === 'TD0005') {
            return res;
        }
        if (!(res && res.success)) {
            ToastUtils.showAbnormalToast(res.msg);
        }
        return res;
    };
    //支付订单
    orderPay = async (data) => {
        let res = await orderPay(data);
        if (!(res && res.success)) {
            ToastUtils.showAbnormalToast(res.msg || '');
        }
        return res;
    };
}
export default new Mall();
